import React from "react";
import { Slider } from "@/components/ui/slider";
import { Input } from "@/components/ui/input";
import { RotateCcw } from "lucide-react";

export default function RotationDial({ value, onChange }) {
  return (
    <div className="bg-slate-900 border border-slate-800 rounded-xl p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="font-mono text-[10px] uppercase tracking-widest text-slate-500" title="Rotates the compass grid over the fixed plan">True North</div>
        <div className="flex items-center gap-1.5">
          <Input
            data-testid="true-north-angle-input"
            type="number"
            value={value}
            step={0.5}
            min={-180}
            max={180}
            onChange={(e) => onChange(Number(e.target.value))}
            className="w-16 h-8 bg-slate-950 border-slate-800 text-slate-100 font-mono text-xs"
          />
          <span className="font-mono text-xs text-slate-500">°</span>
          <button
            data-testid="reset-north-button"
            onClick={() => onChange(0)}
            className="h-8 w-8 flex items-center justify-center rounded-lg text-slate-400 hover:text-slate-100 hover:bg-slate-800"
            title="Reset to 0°"
          >
            <RotateCcw className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>
      <Slider
        data-testid="true-north-rotation-slider"
        value={[value]}
        min={-180}
        max={180}
        step={0.5}
        onValueChange={(v) => onChange(v[0])}
      />
    </div>
  );
}
